import faLang from "./entries/fa-IR"
import { addLocaleData } from "react-intl"

const AppLocale = {
  fa: faLang,
};
addLocaleData(AppLocale.fa.data)

export default AppLocale;
